import type { Organization } from '../api/schemas';

export const ORGANIZATION_MENU_PAGE_SIZE = 8;

export function getVisibleOrganizations(args: {
    organizations: Organization[];
    currentOrganizationId: string | null;
    visibleCount: number;
}): Organization[] {
    const { organizations, currentOrganizationId, visibleCount } = args;
    const slicedOrganizations = organizations.slice(0, visibleCount);

    if (
        !currentOrganizationId ||
        slicedOrganizations.some((organization) => organization.id === currentOrganizationId)
    ) {
        return slicedOrganizations;
    }

    const currentOrganization = organizations.find((organization) => organization.id === currentOrganizationId);

    if (!currentOrganization) {
        return slicedOrganizations;
    }

    return [currentOrganization, ...slicedOrganizations];
}
